import { z } from 'zod';
import { endpoint } from './endpoint.js';
import { MeContextResponseSchema } from '../schemas/me-context.js';

export const meContext = {
  get: endpoint('GET', '/me/context', z.object({}), MeContextResponseSchema),
};
